import { defineMessages } from 'react-intl';

export default defineMessages({
  content: 'Link wygasł.',
  linkMessage: 'Przejdź ponownie do ekranu odzyskiwania hasła.',
});
